/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SimpleWisdomCard from '@ihs/components/Cards/SimpleWisdomCard';

/* Services */
/* Styles */

/**
 * Renders the RelatedPostsContent component
 *
 * @param {object} wisdomData -  Related Stories Data
 * @returns {ReactElement} RelatedPostsContent component
 */
export default function RelatedPostsContent({ wisdomData }) {
  return wisdomData?.length > 0 ? (
    <Box maxW="1030px" mx="auto">
      <Box
        width="100%"
        pt="30px"
        minH={320}
        mx="0"
        pb="80px"
        px={{ base: '20px', md: '0' }}
      >
        <Flex
          flexWrap="wrap"
          justifyContent="center"
          gridColumnGap={{ base: '0', sm: '28px' }}
        >
          {wisdomData.map(post => {
            return <SimpleWisdomCard sectionContent={post} key={nanoid()} />;
          })}
        </Flex>
      </Box>
    </Box>
  ) : null;
}
